'use client';
import React from 'react';
import { gsap } from 'gsap';
import { copyImpactCounter } from './impactCounterSection.copy';
import { useGSAP } from '@gsap/react';
import Link from 'next/link';

interface infoItemProps {
  title: string;
  className: string;
  subCopy: string;
  subCopyUrl: string;
  index: number;
}

const ImpactCounterAnimation = (ref: React.RefObject<HTMLDivElement | null>) => {
  if (!ref.current) return;
  gsap
    .timeline({
      defaults: {
        duration: 0.7,
        ease: 'none',
      },
      scrollTrigger: {
        trigger: ref.current,
        start: 'top 70%',
        toggleActions: 'play none none reverse',
      },
    })
    .from(ref.current.querySelector('.title'), {
      opacity: 0,
      y: 100,
      ease: 'expo.out',
    })
    .from(
      ref.current.querySelector('.count-container'),
      {
        opacity: 0,
        y: 100,
        delay: 0.1,
        ease: 'expo.out',
      },
      '-=0.5',
    )
    .add('add')
    .to(
      ref.current.querySelector('.test-time'),
      {
        textContent: '90',
        roundProps: 'textContent',
        ease: 'none',
        duration: 0.3,
      },
      'add-=0.2',
    )
    .to(
      ref.current.querySelector('.build-time'),
      {
        textContent: '75',
        roundProps: 'textContent',
        ease: 'none',
        duration: 0.3,
      },
      'add-=0.2',
    );
};

const renderCounterItem = ({ title, subCopy, subCopyUrl, className, index }: infoItemProps) => {
  return (
    <div
      key={`box-info-${index}`}
      className="relative flex flex-col gap-2 border-gray-3 px-4 text-left last:border-l md:gap-4 md:px-10"
    >
      <div className="flex flex-col-reverse gap-2 md:flex-row md:gap-8">
        <div className="flex max-w-full gap-4 md:flex md:max-w-full">
          <p className="text-h6 text-gray-4 lg:flex">{title}</p>
        </div>
        <h3 className="text-h3 flex text-gradle-blue">
          <span className={`${className} count-text inline-block w-10 md:w-12 lg:w-14`}>0</span>
          <span>%</span>
        </h3>
      </div>
      <Link href={subCopyUrl} target="_blank" className="text-input-label py-1 italic text-gray-3 hover:underline">
        * {subCopy}
      </Link>
    </div>
  );
};

export const ImpactCounterSection = () => {
  const ref = React.useRef<HTMLDivElement>(null);
  useGSAP(
    () => {
      ImpactCounterAnimation(ref);
    },
    { scope: ref },
  );

  return (
    <div className="py-section px-section w-full text-center text-white" ref={ref}>
      <h4 className="title text-h4 mb-8">Impact by the numbers</h4>
      <div className="count-container inline-flex w-fit justify-center rounded-2xl bg-dark-background py-3 md:w-[45rem] md:py-10 ">
        {copyImpactCounter.map((item, index) => {
          return renderCounterItem({ ...item, index });
        })}
      </div>
    </div>
  );
};
